<div *ngIf="scheduleType==='Private'" class="login-form-container">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8 logo-container">
        <div class="">
          <div class="logo-wrapper">
            <div class="logo">
              <div><img *ngIf="configService.themeConfig && configService.themeConfig.LogoUrl" [src]="configService.themeConfig.LogoUrl" alt="Site Logo"></div>
            </div>
            <div class="logo-content">
              <h1 *ngIf="configService.themeConfig.Heading">{{'userLogin.logoContent' | translate}}</h1>
              <h2 *ngIf="configService.themeConfig.SubHeading !== '' ">{{configService.themeConfig.SubHeading}}</h2>
              <div class="small-description">
                <strong *ngIf="configService.themeConfig.TagLine !== '' ">{{configService.themeConfig.TagLine}}</strong><br>
                <span *ngIf="configService.themeConfig.Description">{{smallDescription}}</span>
                </div>
            </div>
          </div>
        </div>

      </div>
      <div class="col-md-4 login-form">
        <div id="login" class="form-container">
          <div id="login-row" class="justify-content-center align-items-center">
            <div id="login-box">
              <div id="login-column" class="login-column-c">
                <form [formGroup]="loginForm" (ngSubmit)="login()" novalidate>
                  <p class="text-center login-title">{{'examineeLogin.loginForm.title' | translate}}</p>
                  <label for="username" class="text-info">{{'examineeLogin.loginForm.email' | translate}}<span class="error">*</span></label><br>
                  <input type="text" class="form-control" formControlName="email" required [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                  <div *ngIf="submitted && f.email.errors" class="alert alert-danger">
                    <div *ngIf="f.email.errors.required">{{'examineeLogin.loginForm.errorMail' | translate}}</div>
                  </div>
                  <label for="password" class="text-info">{{'examineeLogin.loginForm.password' | translate}}<span class="error">*</span></label><br>
                  <input type="password" class="form-control" formControlName="password" required
                    [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                  <div *ngIf="submitted && f.password.errors" class="alert alert-danger">
                    <div *ngIf="f.password.errors.required">{{'examineeLogin.loginForm.errorPwd' | translate}}</div>
                  </div>
                  <div class="captcha-group">
                    <div class="captcha">
                      <img [src]="CaptchaImgUrl" alt="captcha-image" class="captcha-image img-fluid">
                        <div class="refresh-icon" matTooltip="{{'userLogin.loginForm.toolTip' | translate}}">
                          <mat-icon (click)="resendCaptcha()">refresh</mat-icon>
                        </div>
                    </div>
                    <div class="captcha-input">
                      <label for="captcha" class="text-info">{{'examineeLogin.loginForm.captcha' | translate}}<span class="error">*</span></label><br>
                      <input type="text" class="form-control" formControlName="captchaText" [ngClass]="{ 'is-invalid': submitted && f.captchaText.errors }">
                      <div *ngIf="submitted && f.captchaText.invalid">
                        <div class="alert alert-danger" *ngIf="f.captchaText.errors.required">{{'examineeLogin.loginForm.errorCaptcha' | translate}}</div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <div><a routerLink="" [ngClass]="{'adisabled': disableForgotPass}" (click)="!disableForgotPass ? resetPwd() : ''" class="no-underline">{{'examineeLogin.loginForm.link' | translate}}</a></div>
                    <div>
                      <button type="submit" class="btn-login btn-bg-color" mat-flat-button [disabled]="isValid">
                        <span *ngIf="!loginSpinner">{{'examineeLogin.loginForm.btn' | translate}}</span>
                        <span *ngIf="loginSpinner"><i class="fa fa-spinner fa-spin fa-1x" aria-hidden="true"></i></span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <span *ngIf="!lockoutMsg" class="error-message invalid-feedback">{{ loginErrorMessage }}</span>
              <div *ngIf="lockoutMsg" class="alert alert-danger">
                <div>{{ loginErrorMessage }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="footer-copyrights" id="cp">
    <!-- © {{fullyear}} SimpliAssess, All Rights Reserved. -->
    © {{fullyear}} {{'footer.text' | translate}}
  </div>
</div>
<div *ngIf="err" class="err">
  <div>{{err}}</div>
</div>
